import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * <input type="date"> stores its value as an ISO "yyyy-MM-dd" string, but a
 * known Chromium bug lets the year segment run away past 4 digits when the
 * user scrolls/holds the up-arrow on it (it silently jumps to JS's Date
 * ceiling, year 275760, instead of stopping at 9999). validYearValidator
 * already flags the resulting value as invalid, but that only shows up once
 * the control is touched - this directive clamps the year back to 4 digits
 * the instant it happens, and marks the control touched on every
 * input/scroll so an out-of-range year (still possible within 4 digits,
 * e.g. typing 0001) shows its error immediately instead of waiting on blur.
 */
@Directive({
  selector: 'input[type="date"][formControlName], input[type="date"][formControl]'
})
export class ClampDateYearDirective {
  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement): void {
    const match = /^(\d+)-(\d{2}-\d{2}.*)$/.exec(input.value);
    if (match && match[1].length > 4) {
      const clamped = `${match[1].slice(0, 4)}-${match[2]}`;
      input.value = clamped;
      this.ngControl?.control?.setValue(clamped);
    }
    this.ngControl?.control?.markAsTouched();
  }
}
